<template>
  <a-drawer
    :open="open"
    :title="existing ? '编辑版本草稿' : '新增客户端版本'"
    :width="520"
    @close="$emit('close')"
  >
    <a-form :model="form" layout="vertical" @finish="save">
      <a-form-item label="平台与架构" name="target" required>
        <a-select
          v-model:value="form.target"
          :disabled="Boolean(existing?.file)"
          :options="targets"
        />
      </a-form-item>
      <a-form-item
        label="版本号"
        name="version"
        :rules="[{ required: true, whitespace: true, message: '请填写版本号' }]"
      >
        <a-input v-model:value="form.version" :maxlength="80" placeholder="例如 1.0.0" />
      </a-form-item>
      <a-form-item label="发布渠道" name="channel" required>
        <a-radio-group v-model:value="form.channel"
          ><a-radio value="stable">正式版</a-radio
          ><a-radio value="test">测试版</a-radio></a-radio-group
        >
      </a-form-item>
      <a-form-item v-if="form.target === 'ios'" label="分发方式" name="delivery">
        <a-radio-group v-model:value="form.delivery" :disabled="Boolean(existing?.file)">
          <a-radio value="external">App Store / TestFlight</a-radio
          ><a-radio value="file">上传 IPA</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item
        v-if="form.delivery === 'external'"
        label="官方分发链接"
        name="externalUrl"
        :rules="[{ required: true, message: '请填写官方分发链接' }]"
      >
        <a-input
          v-model:value="form.externalUrl"
          :maxlength="2048"
          placeholder="https://apps.apple.com/… 或 https://testflight.apple.com/…"
        />
      </a-form-item>
      <a-form-item label="更新说明" name="notes"
        ><a-textarea v-model:value="form.notes" :rows="5" :maxlength="10000"
      /></a-form-item>
      <a-form-item
        label="操作说明"
        name="reason"
        :rules="[{ required: true, whitespace: true, message: '请填写操作说明' }]"
      >
        <a-input v-model:value="form.reason" :maxlength="500" />
      </a-form-item>
      <a-alert
        v-if="form.delivery === 'file'"
        type="info"
        show-icon
        message="保存草稿后，在列表中上传安装包；校验完成后再发布。"
      />
      <a-alert v-if="error" type="error" show-icon :message="error" style="margin-top: 16px" />
      <a-button type="primary" html-type="submit" :loading="saving" style="margin-top: 20px"
        >保存草稿</a-button
      >
    </a-form>
  </a-drawer>
</template>
<script setup lang="ts">
import { reactive, ref, watch } from 'vue';
import { CLIENT_RELEASE_TARGETS, type ClientReleaseInput, type ClientReleaseView } from 'shared';
import { useClientReleasesStore } from '@/stores/client-releases.store';
const props = defineProps<{ open: boolean; existing?: ClientReleaseView }>();
const emit = defineEmits<{ close: [] }>();
const store = useClientReleasesStore();
const targets = CLIENT_RELEASE_TARGETS.map((item) => ({ value: item.id, label: item.label }));
const form = reactive<ClientReleaseInput & { reason: string }>({
  target: 'android',
  version: '',
  channel: 'stable',
  notes: '',
  delivery: 'file',
  externalUrl: '',
  reason: '',
});
const saving = ref(false);
const error = ref('');
watch(
  () => props.open,
  (open) => {
    if (!open) return;
    Object.assign(
      form,
      {
        target: 'android',
        version: '',
        channel: 'stable',
        notes: '',
        delivery: 'file',
        externalUrl: '',
        reason: '',
      },
      props.existing ?? {},
    );
    error.value = '';
  },
);
watch(
  () => form.target,
  (target) => {
    if (target !== 'ios') {
      form.delivery = 'file';
      form.externalUrl = '';
    }
  },
);
watch(
  () => form.delivery,
  (delivery) => {
    if (delivery === 'file') form.externalUrl = '';
  },
);
async function save() {
  saving.value = true;
  error.value = '';
  try {
    await store.save(
      {
        target: form.target,
        version: form.version,
        channel: form.channel,
        notes: form.notes,
        delivery: form.delivery,
        externalUrl: form.externalUrl,
      },
      form.reason,
      props.existing,
    );
    emit('close');
  } catch (cause) {
    error.value = (cause as Error).message;
  } finally {
    saving.value = false;
  }
}
</script>
